var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFieldHidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M0.620312 10.5L5.02591 4.5H15.9741L20.3797 10.5L15.9741 16.5H5.02591L0.620312 10.5Z",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 10.5,
    cy: 10.5,
    r: 3,
    fill: "white",
    fillOpacity: 0.1,
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 1L2.5 19.5",
    stroke: "#9C9DA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldHidden);
export default __webpack_public_path__ + "static/media/field_hidden.3ebaf855e9ea1d137321c9165836cc43.svg";
export { ForwardRef as ReactComponent };